import { leaderboardPost, leaderboardUsersPost } from './leaderboard_http_client.js';
import type { GetLeaderboardRes, GetLeaderboardReq, AddScoresReq, AddCountryScoresReq, GetUserDataRes } from './leaderboard.dto.js';
import { VersionLoader } from '../../version_loader.js';

export function getLeaderboard( leaderboardId: string, limit: number ): Promise<GetLeaderboardRes>
{
  const req: GetLeaderboardReq = { leaderboardId, limit };
  return leaderboardPost<GetLeaderboardRes>( 'api/Leaderboard/get', req );
}

export function addScores( leaderboardId: string, scores: number ): Promise<void>
{
  const req: AddScoresReq = { leaderboardId, scores };
  return leaderboardPost<void>( 'api/Leaderboard/scores/add', req );
}

/**
 * Adds stars to the country board (`country:<country>`), as Block Royale does. Without a country
 * the server picks one itself.
 */
export function addCountryScores( scores: number, country?: string ): Promise<void>
{
  const req: AddCountryScoresReq = { scores, ...( country ? { country } : {} ) };
  return leaderboardPost<void>( 'api/Leaderboard/country/scores/add', req );
}

export interface SetUserSaveReq
{
  save: { _player: { _l: number; _nm: string; _av: number; _vers: string; _facebook_av_url?: string } };
  platform: string;
}

export function getUserData(): Promise<GetUserDataRes>
{
  return leaderboardUsersPost<GetUserDataRes>( 'api/User/get' );
}

export function setUserSave( level: number, name: string, avatar: number, facebook_av_url?: string ): Promise<void>
{
  const platform = ( () =>
  {
    try
    {
      const p = ( globalThis as any )?.Capacitor?.getPlatform?.();
      if ( p === 'ios' || p === 'android' ) return p;
    }
    catch {}
    return 'webgl';
  } )();

  const req: SetUserSaveReq = {
    save: { _player: { _l: level, _nm: name, _av: avatar, _vers: 'v' + VersionLoader.getVersion(), ...( facebook_av_url ? { _facebook_av_url: facebook_av_url } : {} ) } },
    platform
  };
  return leaderboardUsersPost<void>( 'api/User/set/save', req );
}
